// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { productPriceStyles } from "@adl/Overrides/Components/ProductPrice";
import { css } from "styled-components";

productPriceStyles.discountWrapper = {
    css: css`
        display: flex;
        align-items: baseline;
    `,
};

productPriceStyles.discountPriceText = {
    variant: "h6",
    color: "common.ui6",
    css: css`
        text-decoration: line-through;
        display: inline-block;
        margin-right: 5px;
        margin-bottom: 0;
    `,
};

productPriceStyles.discountText = {
    color: "success",
    size: "12px",
    weight: "bold",
    lineHeight: "18px",
};

productPriceStyles.tagStyles = {
    color: "success",
    size: 12,
    css: css`
        align-self: center;
        margin: 0 3px;
        opacity: 0.5;
    `,
};
